import {
  ModuleRegistry,
  // ValidationModule /* Development Only */,
  ColumnAutoSizeModule,
  RowStyleModule,
  RowDragModule,
  CellStyleModule,
  TooltipModule,
  CustomFilterModule,
  ExternalFilterModule,
  QuickFilterModule,
  RowSelectionModule,
  CustomEditorModule,
  CsvExportModule,
  DragAndDropModule,
  GridStateModule,
  ColumnApiModule,
  RowApiModule,
  ScrollApiModule,
  RenderApiModule,
  EventApiModule,
  ClientSideRowModelApiModule,
  ClientSideRowModelModule,
  PinnedRowModule
} from 'ag-grid-community';

ModuleRegistry.registerModules([
  // ValidationModule /* Development Only: Enable it when working on the grid, in production it should be disabled */,
  ColumnAutoSizeModule,
  RowStyleModule,
  RowDragModule,
  CellStyleModule,
  TooltipModule,
  CustomFilterModule,
  ExternalFilterModule,
  QuickFilterModule,
  RowSelectionModule,
  CustomEditorModule,
  CsvExportModule,
  DragAndDropModule,
  GridStateModule,
  ColumnApiModule,
  RowApiModule,
  ScrollApiModule,
  RenderApiModule,
  EventApiModule,
  ClientSideRowModelApiModule,
  ClientSideRowModelModule,
  PinnedRowModule
]);
